module.exports = __webpack_public_path__ + "static/media/instagram.aa9fb255.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/instagram.svg
// module id = 608
// module chunks = 0